const registerLocalize = {
    "errorCadastro": "Unable to save, try again!",

};

export default registerLocalize;